import React from 'react';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';
import {Typography, AsTagsForSEO} from '../typography/Typography';
import { AccentColorOptions, ueGradientColors } from 'epic-ue-theme';

const Styled = styled.div<{align: string, $to: string, $from: string}>`
    text-align: ${(p) => p.align};
    padding: 4px 10px;
    width: fit-content;
    background: radial-gradient(100% 185.14% at 100% 100%, ${p => p.$to} 0%, ${p => p.$from} 100%);
    box-shadow: 0px 0px 20px 4px ${p => p.$to}b0;
    color ${p => p.theme.palette.common.black};

    h4 {
        display: inline-block;
    }
`;

export interface RadiantEyebrowProps {
    align?: string;
    as?: AsTagsForSEO;
    children?: React.ReactNode;
    text?: string;
    big?: boolean;
    accentColor?: AccentColorOptions;
}

export const RadiantEyebrow = ({
    align = 'inherit',
    as,
    children,
    text,
    big = false,
    accentColor = 'sky'
}: RadiantEyebrowProps): JSX.Element => {
    const {to, from} = ueGradientColors[accentColor];
    return (
        <Styled $to={to} $from={from} align={align} className={`eyebrow-wrapper loc-${getLocale()}`}>
            {children ? (
                children
            ) : (
                <Typography variant="h4" as={as} big={big}>
                    {text}
                </Typography>
            )}
        </Styled>
    );
};
